import React from "react";

const Section3 = ({ data }) => {
  return (
    <div className="w-full flex justify-center business mb-16 lg:mb-20 ">
      {/* <div className="2xl:container w-full flex flex-col lg:flex-row justify-center px-6 py-20 md:px-10 lg:px-20  md:py-20  gap-6">
        <div className="lg:w-8/12 relative">
          <img
            className="w-full h-full sm:h-[85%] w-auto h-auto"
            src={process.env.PUBLIC_URL + data.whybg}
            alt="background_img"
          />
          <div className=" w-[85%] sm:w-[80%] p-4 md:px-10 lg:px-20  md:py-[56px] absolute max-sm:-bottom-[20vw] bottom-0 right-0 bg-whybg bg-cover bg-bottom bg-no-repeat whyfloat">
            <h1 className="text-18 sm:text-24 md:text-32 text-primarycolor font-semibold">
              {data.why ? data.why : ""}
            </h1>
            <p className="text-14 md:text-18 text-secondaryblack font-regular mt-4 sm:mt-6">
              {data.whydesc ? data.whydesc : ""}
            </p>
          </div>
        </div>
        <div className="lg:w-4/12 bg-footerbg p-7 md:px-12 md:py-10 text-white mt-[120px] lg:mt-0">
          <ol className=" flex flex-col gap-6 text-white">
            {data.reasons
              ? data.reasons.map((reason, i) => (
                  <li className="listborder ">
                    <h1 className="text-20 font-semibold">{i+1}. {reason.heading}</h1>
                    <p className="mt-4 text-16 pb-4 text-[#EDF1FF]">{reason.desc}</p>
                  </li>
                ))
              : ""}
          </ol>
        </div>
      </div> */}
      <div className="2xl:container w-full flex flex-col lg:flex-row justify-center max-lg:items-center px-6 py-16 md:px-10 lg:px-20  md:py-20 gap-10  lg:gap-20">
        <div className="lg:w-2/5 ">
          <img
            className="lg:w-full   h-fit object-center"
            src={process.env.PUBLIC_URL + data.whybg}
            alt="background_img"
          />
        </div>
        <div className="lg:w-3/5">
          <h4 className="text-24 sm:text-32 md:text-48 text-primarycolor font-bold">{data.why ? data.why : ""}</h4>
          <p className="text-14 md:text-16 text-secondaryblack font-regular mt-4 sm:mt-6">
            {data.whydesc ? data.whydesc : ""}
          </p>
          <p className=" w-full border brder-journeyborder my-8"></p>
          <div className="flex flex-col gap-8 w-full lg:w-[75%]">
            {data.reasons
              ? data.reasons.map((reason, i) => (
                <div>
                  <div className="flex gap-4 items-center">
                    <img className="w-[20px] h-[20px]"  src={process.env.PUBLIC_URL + "/images/content/section2/Content Transformation/check icon.svg"} alt="icon" />
                    <h4 className="text-18 font-semibold sm:text-20 text-primarycolor">{reason.heading}</h4>
                  </div>
                  <p className="text-14 sm:text-16 text-secondaryblack font-medium mt-4">{reason.desc}</p>

                </div>)) : <></>}
          </div>
        </div>

      </div>


    </div>
  );
};

export default Section3;
